import { render } from "./QuranAyatFavoriteCard.vue?vue&type=template&id=6c80b6dc"
import script from "./QuranAyatFavoriteCard.vue?vue&type=script&lang=js"
export * from "./QuranAyatFavoriteCard.vue?vue&type=script&lang=js"
script.render = render

export default script